export enum AuthAccessibility {
  onlyLoggedIn,
  onlyNotLoggedIn,
  all,
}
